import { lazy, Suspense, useMemo, useContext } from "react"
import { Loader } from "widgets"
import RouteError from "../base/route-error.js"
import PrivateRoute from "../base/private-route.js"
import { featuresFlatMap } from "utils"
import { AppContext } from "../base/app-context-provider.js"
import MyRequests from "./my-requests.js"

const ManageAgencyRequests = lazy(
  () => import("./manage-agency-requests.js"),
)


export const useHelpDeskRoutes = () => {
  const appContext = useContext(AppContext)
  const features = useMemo(
    () =>
      _.merge(featuresFlatMap(appContext?.user?.featureDTOList)?.["help desk"],featuresFlatMap(appContext?.user?.featureDTOList)?.["my requests"]) ?? {},
    [appContext?.user?.featureDTOList],
  )

  const helpDeskRoutes = useMemo(
    () =>
      _.compact([
        {
          path: "help-desk",
          errorElement: <RouteError />,
          element: <PrivateRoute />,
          children: _.compact([
            features["search-agency-requests"] && {
              path: "manage-agency-requests",
              element: (
                <Suspense fallback={<Loader />}>
                  <ManageAgencyRequests />
                </Suspense>
              ),
            },
            features["search-my-requests"] && {
              path: "my-requests",
              element: (
                <Suspense fallback={<Loader />}>
                  <MyRequests />
                </Suspense>
              ),
            },
          ]),
        },
      ]),
    [features],
  )

  return helpDeskRoutes
}
